import { injectCompanyToURL } from '@helpers'

import Api from '../api'
import { API_COMPANY_TAXATION_DETAILS_URL } from './urls'

export function fetchCompanyTaxationDetails(companyId: number) {
  return Api.get<BackendCompanyTaxationDetails>(injectCompanyToURL(API_COMPANY_TAXATION_DETAILS_URL, companyId))
}
